/**
 * LRC (Longitudinal Redundancy Check) for Ingenico TPE protocol.
 *
 * Computes the XOR of every byte in the input array.
 * The result is appended to payment frames before transmission
 * so the terminal can verify data integrity.
 */
export function calculateLrc(data: Uint8Array): number {
  let lrc = 0;
  for (let i = 0; i < data.length; i++) {
    lrc ^= data[i];
  }
  return lrc;
}
